import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//bootstrap.js for layout
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css' //this has to be last so that custom css -eg Lato font - overrides bootstrap

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
